import {
  GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL,
  GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL,
  UPDATE_RESERVATION_URL,
  SET_RESERVATION_DRIVERS_URL,
  LOGIN_URL,
  CHECKIN_RESERVATION_URL,
  GET_TERMINAL_INFO_BY_ID_URL,
  GET_UI_CONFIG_URL,
} from '../constants/urls'
import validReservation from './validReservation.json'
import invalidReservation from './invalidReservation.json'
import incompleteReservation from './incompleteReservation.json'
import emptyDriver from './forTests/emptyDriver.json'
import emptyDrivers from './forTests/emptyDrivers.json'
import emptyReservation from './forTests/emptyReservation.json'
import incompleteReservationOneDriver from './forTests/incompleteReservationOneDriver.json'
import validReservationOneDriver from './forTests/validReservationOneDriver.json'
import reservationWithAddons from './forTests/reservationWithAddons.json'
import validLogin from './validLogin.json'
import { getStore, keys } from '../actions/localStorage'
import { getCSCId } from '../actions/api'
import {
  ADMIN_LOGIN_URL,
  ADMIN_TERMINAL_URL,
  ADMIN_DEPARTURES_URL,
  ADMIN_CLOSED_DEPARTURES_URL,
} from '../constants/admin/adminUrls'
import terminals from './admin/terminals.json'
import adminLogin from './admin/adminLogin.json'
import reservationForBatchServer from './forTests/reservationForBatchServer.json'
import validReservationNoTrailer from './validReservationNoTrailer.json'
import uiConfig from './uiConfig.json'
import departure from './admin/departuresForNext24hours.json'

const selectGetResponse = (url: string) => {
  window.console.log(url)
  if (url.indexOf(GET_TERMINAL_INFO_BY_ID_URL + `/1234567890`) === 0) {
    return { data: terminals[1] }
  }
  if (url.indexOf(GET_TERMINAL_INFO_BY_ID_URL + `/${getCSCId()}`) === 0) {
    return { data: terminals[0] }
  }
  if (url.includes(ADMIN_DEPARTURES_URL)) {
    return { data: departure }
  }
  if (url.indexOf(ADMIN_TERMINAL_URL) === 0) {
    return { data: terminals }
  }
  if (url.includes(GET_UI_CONFIG_URL)) {
    return { data: uiConfig }
  }
  return {}
}
const selectPostResponse = (url: string, data: any) => {
  window.console.log(url)
  if (
    url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) &&
    [11111111, 22222222, 12222222, 13333333, 14444444, 15555555, 16666666, 17777777].includes(data.resId)
  ) {
    return { data: null }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL) && data.resId === 22222222) {
    return { data: incompleteReservation }
  }
  //// with 'RIG'
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL) && data.resId === 32222222) {
    return { data: { ...validReservation, route: { ...validReservation.route, portFrom: 'HEL' } } }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL) && data.resId === 31222223) {
    return {
      data: { ...validReservationOneDriver, route: { ...validReservationOneDriver.route, portFrom: 'HEL' } },
    }
  }
  ////GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL) && data.resId === 12222222) {
    return { data: validReservation }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL) && data.resId === 13333333) {
    return { data: validReservationOneDriver }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL) && data.resId === 14444444) {
    return { data: emptyDriver }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL) && data.resId === 15555555) {
    return { data: emptyDrivers }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL) && data.resId === 16666666) {
    return { data: emptyReservation }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL) && data.resId === 17777777) {
    return { data: incompleteReservationOneDriver }
  }
  ////GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) && data.resId === 11111112) {
    return { data: incompleteReservation }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) && data.resId === 12222223) {
    return { data: validReservationOneDriver }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) && data.resId === 13333334) {
    return { data: emptyDriver }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) && data.resId === 14444445) {
    return { data: emptyDrivers }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) && data.resId === 15555556) {
    return { data: emptyReservation }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) && data.resId === 16666667) {
    return { data: incompleteReservationOneDriver }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) && data.resId === 20000000) {
    return { data: reservationForBatchServer }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) && data.resId === 0) {
    return {
      error: true,
      response: {
        status: 400,
        data: invalidReservation,
      },
    }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) && data.resId === 32222222) {
    return { data: { ...validReservation, route: { ...validReservation.route, portFrom: 'HEL' } } }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) && data.resId === 31222223) {
    return {
      data: { ...validReservationOneDriver, route: { ...validReservationOneDriver.route, portFrom: 'HEL' } },
    }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) && data.resId === 44444444) {
    return { data: validReservationNoTrailer }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) && data.resId === 99999999) {
    return { data: { ...validReservation, checkedIn: true } }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) && data.resId === 50000000) {
    return { data: reservationWithAddons }
  }
  //Without Vehicle Card
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL) && data.resId === 99999998) {
    return {
      data: { ...validReservation, checkedIn: true, route: { ...validReservation.route, portFrom: 'HEL' } },
    }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL)) {
    return { data: validReservation }
  }
  ////GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL) && data.regNumber === '1') {
    return { data: validReservation }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL) && data.regNumber === '0') {
    return { data: null }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL) && data.regNumber === 'error') {
    return {
      error: true,
      response: {
        status: 400,
        data: { message: 'error message' },
      },
    }
  }
  if (url.includes(GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL) && data.regNumber === '9999') {
    return { data: { ...validReservation, checkedIn: true } }
  }
  if (url.includes(SET_RESERVATION_DRIVERS_URL)) {
    return { data: data }
  }
  if (url.indexOf(LOGIN_URL) === 0) {
    return { data: validLogin }
  }
  if (url.includes(CHECKIN_RESERVATION_URL) && data.resId === 20000000) {
    return {
      error: true,
      response: {
        status: 400,
        data: {
          message:
            '500 Internal Server Error\\n{"errors":["Res. ID #61769599 is being edited by BATCH operator \\"BATCH_SERVER (RES CHECK STATE)\\", workstation \\"APTLL052T\\""],"warnings":[],"detailedWarnings":{}}',
        },
      },
    }
  }
  if (url.includes(CHECKIN_RESERVATION_URL) && data.resId === 50000000) {
    return { data: reservationWithAddons }
  }
  if (url.includes(CHECKIN_RESERVATION_URL)) {
    return { data: validReservation }
  }
  //admin
  if (url.includes(ADMIN_LOGIN_URL) && data.username === 'invalid') {
    return { data: null }
  }
  if (url.includes(ADMIN_LOGIN_URL) && data.username === 'old') {
    return {
      error: true,
      status: 401,
      response: {
        data: { message: 'error message' },
      },
    }
  }
  if (url.includes(ADMIN_LOGIN_URL)) {
    return { data: adminLogin }
  }
  if (url.includes(ADMIN_DEPARTURES_URL)) {
    return { data: null }
  }
  if (url.indexOf(ADMIN_TERMINAL_URL) === 0) {
    return { data: null }
  }
  if (url.includes(ADMIN_CLOSED_DEPARTURES_URL)) {
    return {
      status: 200,
      data: null,
    }
  }
}
const selectPutResponse = (url: string, data: any) => {
  if (url.includes(UPDATE_RESERVATION_URL)) {
    return { data: data }
  }
  if (url.includes(ADMIN_TERMINAL_URL)) {
    return { data: null }
  }
  return {}
}
const selectDeleteResponse = (url: string) => {
  window.console.log(url)
  if (url.includes(ADMIN_CLOSED_DEPARTURES_URL)) {
    return {
      status: 200,
      data: null,
    }
  }
  return {}
}

const selectHeadResponse = (url: string) => {
  window.console.log('self check request', url)
  if (getStore(keys.OUT_OF_SERVICE)) {
    return {
      error: true,
      status: 400,
    }
  }

  return {
    status: 200,
    data: '',
  }
}

const resolveDelay = (arg: any): typeof arg => new Promise((resolve) => setTimeout(() => resolve(arg), 1000))

const mockHttpResolver = (data: any) => {
  const addHttpTimeout = getStore(keys.ADD_HTTP_TIMEOUT)
  return addHttpTimeout ? resolveDelay(data) : data && data.error ? Promise.reject(data) : Promise.resolve(data)
}

const get = (url: string) => mockHttpResolver(selectGetResponse(url))
const post = (url: string, data: any) => mockHttpResolver(selectPostResponse(url, data))
const put = (url: string, data: any) => mockHttpResolver(selectPutResponse(url, data))
const deleteFn = (url: string) => mockHttpResolver(selectDeleteResponse(url))
const head = (url: string) => mockHttpResolver(selectHeadResponse(url))
export default { get, post, put, delete: deleteFn, head }
